import {array, number, object, Schema} from "yup";
import {IWayPointCreationSingleVoyage} from "@containers/singleVoyage/types/point";
import {findCloseStopsSingleVoyage} from "@containers/singleVoyage/containers/closeStops/findCloseStops";
import {buildCloseStopsMessage} from "@containers/singleVoyage/containers/closeStops/closeStopsMessages";
import {stringReqSchema} from "@helpers/validate/validateSchema";
import i18n from 'i18next';

export const buildValidateSchemaMutateSingleVoyages = (): Schema => {
    return object({
        wayPoints: array().min(2, i18n.t('singleVoyage.minPointLengthMessage'))
            .test('closeStops', (points, context) => {
                const conflicts = findCloseStopsSingleVoyage(points as IWayPointCreationSingleVoyage[] | undefined)
                return !conflicts.length || context.createError({message: buildCloseStopsMessage(conflicts)})
            }),
        routeInfo: buildValidateSchemaRouteInfoMutateSingleVoyages()
    })
}

export const buildValidateSchemaRouteInfoMutateSingleVoyages = (): Schema => {
    return object({
        deviceId: number().min(1).required(i18n.t('reqText')).typeError(i18n.t('reqText')).min(1, i18n.t('reqText')),
        title: stringReqSchema,
        accountId:stringReqSchema
    })
}